import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw !== pw2) {
      toast.error("Passwords do not match");
      return;
    }
    if (pw.length < 6) {
      toast.error("Password must be at least 6 characters");
      return;
    }
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pw });
      toast.success("Password updated — please log in");
      navigate("/login");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-[calc(100vh-4rem)] flex items-center justify-center px-4 py-12">
      <div className="w-full max-w-md bp-card rounded-2xl p-8">
        <div className="overline mb-2">Reset</div>
        <h1 className="font-heading text-3xl text-white font-light tracking-tight mb-6">
          Choose a new password
        </h1>
        {!token ? (
          <div className="text-sm text-red-400">
            Missing reset token. Please use the link in your email.
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <div>
              <Label className="text-gray-300">New password</Label>
              <Input
                data-testid="reset-password"
                type="password"
                required
                minLength={6}
                value={pw}
                onChange={(e) => setPw(e.target.value)}
                className="mt-1 bg-[#050914] border-white/10 text-white focus:border-[#D4AF37]"
              />
            </div>
            <div>
              <Label className="text-gray-300">Confirm password</Label>
              <Input
                data-testid="reset-password-confirm"
                type="password"
                required
                value={pw2}
                onChange={(e) => setPw2(e.target.value)}
                className="mt-1 bg-[#050914] border-white/10 text-white focus:border-[#D4AF37]"
              />
            </div>
            <Button type="submit" disabled={busy} className="w-full btn-gold rounded-full h-11" data-testid="reset-submit">
              {busy ? "Updating..." : "Update password"}
            </Button>
          </form>
        )}
        <div className="text-center text-sm text-gray-400 mt-6">
          <Link to="/login" className="text-[#D4AF37] hover:underline">
            Back to login
          </Link>
        </div>
      </div>
    </div>
  );
}
